// extracted by mini-css-extract-plugin
export var container = "success-message-module--container--9360e";
export var content = "success-message-module--content--c60d5";
export var titleText = "success-message-module--title-text--2a3bf";